import React, { useRef, useState } from 'react';
import { useTranslate } from '@im/react-localization';
import { Box } from '@mui/system';
import Drawer from '@mui/material/Drawer';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import styled from '@mui/material/styles/styled';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

export default function TableSetting(props: any) {
  const columnGroups = props?.columnGroups.map((colGrp: any) => colGrp.name);
  const Item = styled(Paper)(({ theme }) => ({
    '.css-1bl20zi-MuiStack-root>:not(style)+:not(style)': {
      marginTop: 5,
    },
    alignItems: 'center',
    backgroundColor:
      theme.palette.mode === 'dark'
        ? theme.palette.grey[900]
        : theme.palette.common.white,
    color: theme.palette.text.secondary,
    display: 'flex',
    fontSize: theme.typography.body2.fontSize,
    gap: theme.spacing(1.25),
    height: 48,
    marginTop: theme.spacing(0.75),
    padding: `${theme.spacing(1)} ${theme.spacing(1.25)}`,
  }));
  const translate = useTranslate();
  const dragItem = useRef<any>(null);
  const dragOverItem = useRef<any>(null);
  const [navItems, setNavItems] = useState<string[]>(columnGroups);
  const HandelDragMoves = () => {
    const currentNav = [...navItems];
    const draggedItem = currentNav.splice(dragItem.current, 1)[0];
    currentNav.splice(dragOverItem.current, 0, draggedItem);
    dragItem.current = null;
    dragOverItem.current = null;
    setNavItems(currentNav);
    props.setSortableList(currentNav);
  };
  const handleClose = () => {
    props.close();
  };
  return (
    <Box role="presentation">
      <Drawer
        anchor="right"
        data-testid="gds-vp-ss-tablesettingDrawer"
        onClose={handleClose}
        open={true}
        sx={(theme) => ({
          '.MuiDrawer-paperAnchorRight': {
            color: theme.palette.text.primary,
            p: theme.spacing(2),
            width: 400,
          },
        })}
      >
        <Stack
          alignContent="center"
          direction="row"
          justifyContent="space-between"
          sx={(theme) => ({
            borderBottom: `1px solid ${theme.palette.grey[300]}`,
          })}
        >
          <Typography
            sx={(theme) => ({
              alignContent: 'center',
              display: 'grid',
              fontSize: theme.typography.body1.fontSize,
              fontWeight: theme.typography.fontWeightBold,
            })}
          >
            {translate('Common.TableSettings')}
          </Typography>
          <IconButton
            data-testid="gds-vp-ss-tablesettings-close"
            onClick={handleClose}
          >
            <CloseIcon />
          </IconButton>
        </Stack>
        <Typography
          my={1}
          sx={(theme) => ({
            fontSize: theme.typography.body2.fontSize,
            lineHeight: theme.typography.body2.lineHeight,
          })}
        >
          {translate('Common.ReorderColumns')}
        </Typography>
        <Stack spacing={2}>
          {navItems.map((nav, index) => (
            <Item
              data-testid={`gds-vp-ss-tablesettings-drag-${index}`}
              draggable
              key={nav}
              onDragEnd={HandelDragMoves}
              onDragEnter={() => (dragOverItem.current = index)}
              onDragOver={(e) => e.preventDefault()}
              onDragStart={() => (dragItem.current = index)}
              sx={{
                cursor: 'grab',
              }}
            >
              <DragIndicatorIcon color={'primary'} /> {nav}
            </Item>
          ))}
        </Stack>
      </Drawer>
    </Box>
  );
}
